import React from 'react'
import { bool } from 'prop-types'
import { ROOT, SETTINGS_PAGE } from '../../constants/links'
import redirectTo from '../../utils/redirect/redirectTo'

export default class RegisterMFACompleteStep extends React.Component {
  render() {
    const { isFromSettings } = this.props

    return isFromSettings ? redirectTo(SETTINGS_PAGE) : redirectTo(ROOT)
  }
}

RegisterMFACompleteStep.propTypes = {
  isFromSettings: bool
}
